export { default as MenuIcon } from "./menu.svg";
export { default as FacebookIcon } from "./fb.svg";
export { default as InstagramIcon } from "./ig.svg";
export { default as YoutubeIcon } from "./youtube.svg";
export { default as TreesIcon } from "./grey-trees.svg";
export { default as ArrowIcon } from "./arrow-icon.svg";
export {default as TickIcon} from "./tick.svg";
export {default as PhoneIcon} from "./call.svg";
export {default as EnvelopeIcon } from './envelope.svg';